const DEFAULT_API_BASE_URL = '/api';

function getWindowOrigin(): string | undefined {
  if (typeof window === 'undefined') {
    return undefined;
  }

  const origin = window.location.origin;
  if (!origin || origin === 'null') {
    return undefined;
  }

  return origin;
}

export function getApiBaseUrl(): string {
  const configuredBaseUrl = import.meta.env.VITE_API_BASE_URL;
  const normalizedBaseUrl = typeof configuredBaseUrl === 'string'
    ? configuredBaseUrl.trim()
    : '';

  return normalizedBaseUrl || DEFAULT_API_BASE_URL;
}

export function buildApiUrl(pathname: string): string {
  const normalizedPathname = pathname.replace(/^\/+/, '');
  const apiBaseUrl = getApiBaseUrl();
  const windowOrigin = getWindowOrigin();

  if (!windowOrigin) {
    if (/^https?:\/\//i.test(apiBaseUrl)) {
      return new URL(normalizedPathname, `${apiBaseUrl.replace(/\/+$/, '')}/`).toString();
    }

    return `${apiBaseUrl.replace(/\/+$/, '')}/${normalizedPathname}`;
  }

  return new URL(normalizedPathname, `${new URL(apiBaseUrl, windowOrigin).toString().replace(/\/+$/, '')}/`).toString();
}

export function getApiOrigin(): string | undefined {
  const apiBaseUrl = getApiBaseUrl();
  const windowOrigin = getWindowOrigin();

  if (!windowOrigin && !/^https?:\/\//i.test(apiBaseUrl)) {
    return undefined;
  }

  try {
    const resolvedBaseUrl = windowOrigin ? new URL(apiBaseUrl, windowOrigin) : new URL(apiBaseUrl);
    return resolvedBaseUrl.origin;
  } catch {
    return windowOrigin;
  }
}
